import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c9966514&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9966514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9966514')) {
      api.createRecord('c9966514', component.options)
    } else {
      api.reload('c9966514', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c9966514&scoped=true", function () {
      api.rerender('c9966514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/frame/page/skip/index.vue"
export default component.exports